// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Google = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Google = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Google = _exports.Google = function Google(props) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/React.createElement("path", {
      fill: "#4285F4",
      d: "M18.8 10.207q-.002-.975-.167-1.875H10v3.55h4.933a4.23 4.23 0 0 1-1.841 2.758v2.309h2.975c1.733-1.6 2.733-3.95 2.733-6.742"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#34A853",
      d: "M10 19.167c2.475 0 4.55-.817 6.066-2.217l-2.975-2.308c-.816.55-1.858.883-3.091.883-2.384 0-4.409-1.608-5.134-3.775h-3.05v2.367c1.509 2.991 4.6 5.05 8.184 5.05"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#FBBC05",
      d: "M4.865 11.74A5.5 5.5 0 0 1 4.574 10c0-.608.108-1.192.291-1.742V5.891h-3.05a9.05 9.05 0 0 0-.983 4.108c0 1.483.358 2.875.983 4.108l2.375-1.85z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#EA4335",
      d: "M10 4.482c1.35 0 2.55.467 3.508 1.367l2.625-2.625C14.541 1.74 12.475.832 10 .832 6.416.832 3.325 2.89 1.816 5.89l3.05 2.367C5.591 6.09 7.616 4.482 10 4.482"
    }));
  };
});
